import { getCardRegistry } from '@/lib/cards';
import {
  OrgOverviewCard,
  OrgMembersCard,
  OrgBillingCard,
  OrgAuditLogCard,
  FutureWriteActionsCard,
} from './AllCards';

/**
 * Register all organisation card components
 */
export function registerOrganisationCardComponents() {
  const registry = getCardRegistry();

  registry.register('org.overview', OrgOverviewCard);
  registry.register('org.members', OrgMembersCard);
  registry.register('org.billing', OrgBillingCard);
  registry.register('org.audit_log', OrgAuditLogCard);
  registry.register('org.future_write_actions', FutureWriteActionsCard);
}

export {
  OrgOverviewCard,
  OrgMembersCard,
  OrgBillingCard,
  OrgAuditLogCard,
  FutureWriteActionsCard,
};
